import { render, staticRenderFns } from "./propertyRat.vue?vue&type=template&id=246373c4&scoped=true&"
import script from "./propertyRat.vue?vue&type=script&lang=js&"
export * from "./propertyRat.vue?vue&type=script&lang=js&"
import style0 from "./propertyRat.vue?vue&type=style&index=0&id=246373c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246373c4",
  null
  
)

export default component.exports